export default {
  list: (state) => state.list,
  templateList: (state) => state.templateList,
  store: (state) => state.store,
  iframeSrc: (state) => state.iframeSrc,
  apparelSizes: (state) => state.apparelSizes,
};
